import axios from "axios"
import React from "react";
import { AXIOS_API_URL } from "../../../../setup"
import AuthService from "../../auth/redux/AuthService";


export const AnaVezneCustomersCall = async (setCustomers: React.Dispatch<React.SetStateAction<any>>, setIsLoading: React.Dispatch<React.SetStateAction<boolean | undefined>>) => {
    try {
       await axios.post(`${AXIOS_API_URL}GetRptCsumSf`).then((res) => res.data).then(data => {
        setCustomers(data)
        setIsLoading(false)
       })
    } catch (err) {
        console.log(err)
    }
}

export const AnaVezneStoreCall = async (setStores: any ) => {
    try {
        await axios.post(`${AXIOS_API_URL}GetVezneList` ).then((res) => res.data).then(data => setStores(data))
    } catch (err) {
        console.log(err)
    }
}

export const GetBillTable = async (setBills: React.Dispatch<React.SetStateAction<any>>, customerReference: string) => {
    let data;
    try {
        data = await axios.post(`${AXIOS_API_URL}GetDetailSfByCustomerReferenceRequestModel`, {customerreference: customerReference } ).then((res) => res.data)
        setBills(data)
    } catch (err) {
        console.log(err)
        data = undefined
    }
}

export const GetCustomers = async (setCustomers: React.Dispatch<React.SetStateAction<any>>, setIsLoading: React.Dispatch<React.SetStateAction<boolean>>, salesPersonReference: string ) => {
    try {
        await axios.post(`${AXIOS_API_URL}GetCustomerTableOfAnaveznelistByCustomerId`, {salesPersonReference: salesPersonReference} ).then((res) => res.data).then(data => {
            if(data.Status === 'SUCCESS') {
                setCustomers(data)
                setIsLoading(false)
            }
            return data
        }).then((data) => console.log(data))
        
    } catch (err) {
        console.log(err)
    }
}

export const UpdateCustomerStore = async (customerReference: string, storeId: string, storeDesc: string ) => {
    try {
        await axios.post(`${AXIOS_API_URL}AddOrUpdateCustomerDetail`, {CustomerReference: customerReference, Value: storeId, StoreDesc: storeDesc})
    } catch (error) {
        console.log(error)
    }
}

export const GetAdminTahsilatCustomers = async (CustName: string, setCustomers: React.Dispatch<React.SetStateAction<any>>, setIsLoading: React.Dispatch<React.SetStateAction<boolean>>) => {
    try {
        await axios.post(`${AXIOS_API_URL}GetRptCsumSfWithDetailsUseParameter`, {CustName: CustName}).then(res => res.data).then(data => {
            if(data.Status === 'SUCCESS') {
                setCustomers(data)
                setIsLoading(false)
            }})
    } catch (error) {
        console.log(error)
    }
}

export const GetCustomerContactInfo = async (CustomerReference: string, setEmail: React.Dispatch<React.SetStateAction<string>>, setSms: React.Dispatch<React.SetStateAction<string>>, setPrimaryContactName: React.Dispatch<React.SetStateAction<string>>) => {
    try {
        await axios.post(`${AXIOS_API_URL}GetCustomerByCustomerreference`, { customerReference: CustomerReference}).then((res:any) =>res.data).then((data: any) => {
            if(data.Status === 'SUCCESS') {
                setEmail(data.Detail.EmailAddress)
                setSms(data.Detail.MobilePhoneNumber)
                setPrimaryContactName(data.Detail.PrimaryContactName)
            }
        })
    } catch (error) {
        console.log(error)
    }
}

export const GetCustomersByExcel = async (customers: any[]) => {
    let data = {
        TahsilatItems: customers
    }
    try {
        axios.post(`${AXIOS_API_URL}DownloadAsExceltahsilatGicvenCustomerData`, data, {
            headers: { 
                'Content-Disposition': "attachment; filename=template.xlsx",
            },            
            responseType: 'arraybuffer',
            
        })
        .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Tahsilat Müşteri Listesi.xlsx');
            document.body.appendChild(link);
            link.click();
        })
    } catch (error) {
        console.log(error)
    }
}

export const GetAnaVezneCustomerByExcell = (customerList: any[]) => {
    
    try {
        axios.post(`${AXIOS_API_URL}DownloadDetailTahsilatanavezneAsExcelByGivenData`,{AnavezneExcelItems: customerList}, {
            headers: { 
                'Content-Disposition': "attachment; filename=template.xlsx",
                'Content-Type': 'application/json'
            },            
            responseType: 'arraybuffer'
        })
        .then(res => res.data)
        .then(data => {
            const url = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Ana Vezne Müşteri Listesi.xlsx');
            document.body.appendChild(link);
            link.click();
        })
    } catch (error) {
        console.log(error)
    }
}


export const UploadCustomersFromExcell = async (file: any): Promise<any> => {

    var bodyFormData = new FormData();
    bodyFormData.append('file', file);

    var responseEntity: any;
    await axios.post(`${AXIOS_API_URL}AddCustomerDetailFromExcel`, bodyFormData, { headers: { "Content-Type": "multipart/form-data" } })
        .then(function (response) {
            //handle success 
            console.log("ok", response?.data?.detailResponse);
            responseEntity = response?.data;
        })
        .catch(function (response) {
            //handle error
            console.log("bad", response);
        });
    console.log("responseEntity =>", responseEntity);
    return responseEntity;
}